import mapboxgl from 'mapbox-gl';

// Mapbox configuration
mapboxgl.accessToken = 'pk.eyJ1IjoiZ2FpYW5ldGVjb3N5c3RlbW1hcCIsImEiOiJjbWVyMHdudngwMWxkMmlxeXQwdjEycXQxIn0.4m6ycLsmBBu4GQ7ZGTtjtA';

// Data URL
const DATA_URL = 'https://gaianet-globe-data.s3.amazonaws.com/gaianet-globe-data.json';

// Create the map
const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/satellite-streets-v12',
    projection: 'globe',
    center: [0, 30],
    zoom: 2,
    antialias: true
});

// Add navigation controls
map.addControl(new mapboxgl.NavigationControl());

// Add globe atmosphere
map.on('style.load', () => {
    map.setFog({
        'color': 'rgb(186, 210, 235)',
        'high-color': 'rgb(36, 92, 223)',
        'horizon-blend': 0.02,
        'space-color': 'rgb(11, 11, 25)',
        'star-intensity': 0.6
    });
});

// Load and display data
map.on('load', async () => {
    try {
        console.log('Fetching data from:', DATA_URL);
        
        const response = await fetch(DATA_URL);
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const geoJSON = await response.json();
        console.log('Data loaded:', geoJSON.properties);
        
        // Add source
        map.addSource('gaianet-data', {
        type: 'geojson',
            data: geoJSON
        });
        
        // Add layer for projects (green dots)
    map.addLayer({
            id: 'projects-layer',
        type: 'circle',
            source: 'gaianet-data',
            filter: ['==', ['get', 'type'], 'Projects'],
        paint: {
                'circle-radius': 6,
            'circle-color': '#4CAF50',
            'circle-stroke-color': '#fff',
                'circle-stroke-width': 2,
                'circle-opacity': 0.95
        }
    });

        // Add layer for members (blue dots)
    map.addLayer({
        id: 'members-layer',
        type: 'circle',
            source: 'gaianet-data',
            filter: ['==', ['get', 'type'], 'Members'],
        paint: {
                'circle-radius': 5,
            'circle-color': '#2196F3',
            'circle-stroke-color': '#fff',
                'circle-stroke-width': 2,
                'circle-opacity': 0.95
            }
        });
        
        // Popup handler
        const showPopup = (e: mapboxgl.MapMouseEvent) => {
            if (!e.features || !e.features[0] || !e.features[0].properties) return;
            
            const props = e.features[0].properties!;
            const coords = (e.features[0].geometry as any).coordinates.slice();
            const isProject = props.type === 'Projects';
            
                new mapboxgl.Popup()
                .setLngLat(coords)
                    .setHTML(`
                    <h3>${props.name}</h3>
                    ${props.logoUrl ? `<img src="${props.logoUrl}" style="max-width: 200px; margin: 10px 0; border-radius: 4px;" />` : ''}
                    ${props.pictureUrl ? `<img src="${props.pictureUrl}" style="max-width: 200px; margin: 10px 0; border-radius: 4px;" />` : ''}
                    <p><strong>Location:</strong> ${props.location}</p>
                    ${props.sector || props.sectors ? `<p><strong>Sector:</strong> ${props.sector || props.sectors}</p>` : ''}
                    ${props.description || props.bio ? `<p>${(props.description || props.bio).substring(0, 200)}...</p>` : ''}
                    ${props.networks ? `<p><strong>Networks:</strong> ${props.networks}</p>` : ''}
                    ${props.website ? `<p><a href="${props.website}" target="_blank" style="color: ${isProject ? '#4CAF50' : '#2196F3'};">Visit Website →</a></p>` : ''}
                    `)
                    .addTo(map);
        };
        
        // Click handlers
        map.on('click', 'projects-layer', showPopup);
        map.on('click', 'members-layer', showPopup);
        
        // Hover cursor
        map.on('mouseenter', 'projects-layer', () => {
        map.getCanvas().style.cursor = 'pointer';
    });
        map.on('mouseleave', 'projects-layer', () => {
        map.getCanvas().style.cursor = '';
    });
    map.on('mouseenter', 'members-layer', () => {
        map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', 'members-layer', () => {
        map.getCanvas().style.cursor = '';
    });
        
        // Setup filters
        setupFilters(geoJSON);
        
        // Initialize counter
        document.getElementById('totalCount')!.textContent = geoJSON.features.length.toString();
        document.getElementById('visibleCount')!.textContent = geoJSON.features.length.toString();
        
        console.log('✅ Globe loaded successfully!');
        console.log(`   Projects: ${geoJSON.properties.projectsCount}`);
        console.log(`   Members: ${geoJSON.properties.membersCount}`);
        
    } catch (error: any) {
        console.error('❌ Failed to load data:', error);
        alert(`Error loading globe: ${error?.message || 'Unknown error'}`);
    }
});

// Setup filter functionality
function setupFilters(geoJSON: any) {
    const sectors = [
        'Arts Culture & Music',
        'Food Environment Water & Wildlife',
        'Health & Wellness',
        'Housing Infrastructure & Transport',
        'Indigenous & Ancient Wisdom',
        'Justice Sovereignty & Governance',
        'Learning & Education',
        'Love & Sexuality',
        'Media & Communication',
        'Relations Peacebuilding & Community',
        'Resource Sharing Economics & Trade',
        'Science Technology & Energy',
        'Spirituality Personal Development & Consciousness'
    ];
    
    // Populate sector dropdown
    const sectorFilter = document.getElementById('sectorFilter') as HTMLSelectElement;
    sectors.forEach(sector => {
        const option = document.createElement('option');
        option.value = sector;
        option.textContent = sector;
        sectorFilter.appendChild(option);
    });

    // Map of cities/abbreviations to their countries
    const cityToCountry: { [key: string]: string } = {
        // Abbreviations
        'USA': 'United States',
        'US': 'United States',
        'UK': 'United Kingdom',
        'UAE': 'United Arab Emirates',
        
        // European cities
        'Amsterdam': 'Netherlands',
        'The Hague': 'Netherlands',
        'Utrecht': 'Netherlands',
        'Winsum': 'Netherlands',
        'Berlin': 'Germany',
        'Munich': 'Germany',
        'Hamburg': 'Germany',
        'Frankfurt': 'Germany',
        'London': 'United Kingdom',
        'Manchester': 'United Kingdom',
        'Edinburgh': 'United Kingdom',
        'Glasgow': 'United Kingdom',
        'Exeter': 'United Kingdom',
        'Paris': 'France',
        'Barcelona': 'Spain',
        'Madrid': 'Spain',
        'Rome': 'Italy',
        'Milan': 'Italy',
        'Vienna': 'Austria',
        'Brussels': 'Belgium',
        'Lisbon': 'Portugal',
        'Dublin': 'Ireland',
        'Copenhagen': 'Denmark',
        'Stockholm': 'Sweden',
        'Oslo': 'Norway',
        'Helsinki': 'Finland',
        'Prague': 'Czech Republic',
        'Warsaw': 'Poland',
        'Budapest': 'Hungary',
        'Zurich': 'Switzerland',
        'Geneva': 'Switzerland',
        'Athens': 'Greece',
        'Belgrade': 'Serbia',
        'Bucharest': 'Romania',
        'Sofia': 'Bulgaria',
        'Moscow': 'Russia',
        
        // North American cities
        'New York': 'United States',
        'San Francisco': 'United States',
        'Los Angeles': 'United States',
        'Chicago': 'United States',
        'Boston': 'United States',
        'Seattle': 'United States',
        'Austin': 'United States',
        'Portland': 'United States',
        'Denver': 'United States',
        'Miami': 'United States',
        'Atlanta': 'United States',
        'Washington': 'United States',
        'Berkeley': 'United States',
        'Boulder': 'United States',
        'Santa Fe': 'United States',
        'Richmond': 'United States',
        'Folsom': 'United States',
        'Grass Valley': 'United States',
        'Bay Area': 'United States',
        'Toronto': 'Canada',
        'Montreal': 'Canada',
        'Vancouver': 'Canada',
        'Calgary': 'Canada',
        'Ottawa': 'Canada',
        'Qualicum Beach': 'Canada',
        'Mexico City': 'Mexico',
        'Tulum': 'Mexico',
        'Matamoros': 'Mexico',
        
        // Central/South American cities
        'Rio de Janeiro': 'Brazil',
        'Sao Paulo': 'Brazil',
        'Teresopolis': 'Brazil',
        'Buenos Aires': 'Argentina',
        'Santiago': 'Chile',
        'Bogota': 'Colombia',
        'Lima': 'Peru',
        'Nosara': 'Costa Rica',
        'Ometepe': 'Nicaragua',
        'Lake Atitlan': 'Guatemala',
        
        // Asian cities
        'Tokyo': 'Japan',
        'Beijing': 'China',
        'Shanghai': 'China',
        'Hong Kong': 'China',
        'Mumbai': 'India',
        'Delhi': 'India',
        'Bengaluru': 'India',
        'Hyderabad': 'India',
        'Kharghar': 'India',
        'Bangkok': 'Thailand',
        'Seoul': 'South Korea',
        'Singapore': 'Singapore',
        'Taipei': 'Taiwan',
        'Manila': 'Philippines',
        'Jakarta': 'Indonesia',
        'Bali': 'Indonesia',
        'Kuala Lumpur': 'Malaysia',
        
        // Other cities
        'Sydney': 'Australia',
        'Melbourne': 'Australia',
        'Tel Aviv': 'Israel',
        'Jerusalem': 'Israel',
        'Dubai': 'United Arab Emirates',
        'Istanbul': 'Turkey',
        'Cairo': 'Egypt',
        'Nairobi': 'Kenya',
        'Cape Town': 'South Africa',
        'Johannesburg': 'South Africa'
    };
    
    // Get unique countries from data (map cities to countries)
    const countries = new Set<string>();
    geoJSON.features.forEach((f: any) => {
        const location = f.properties.location;
        if (!location || location === 'Unknown' || location === 'Global') return;
        
        // Map city to country, or use as-is if already a country
        const country = cityToCountry[location] || location;
        countries.add(country);
    });
    
    // Populate country dropdown
    const countryFilter = document.getElementById('countryFilter') as HTMLSelectElement;
    Array.from(countries).sort().forEach(country => {
        const option = document.createElement('option');
        option.value = country;
        option.textContent = country;
        countryFilter.appendChild(option);
    });
    
    
    // Apply filters function
    const applyFilters = () => {
        console.log('🔍 Applying filters...');
        
        const typeFilter = (document.getElementById('typeFilter') as HTMLSelectElement).value;
        const sectorFilter = (document.getElementById('sectorFilter') as HTMLSelectElement).value;
        const countryFilter = (document.getElementById('countryFilter') as HTMLSelectElement).value;
        const showGlobal = (document.getElementById('showGlobal') as HTMLInputElement).checked;
        const searchInput = (document.getElementById('search') as HTMLInputElement).value.toLowerCase().trim();
        
        // Filter data client-side
        const filteredData = geoJSON.features.filter((f: any) => {
            // Global filter
            if (!showGlobal && f.properties.locationType === 'special') {
                return false;
            }
            
            // Type filter
            if (typeFilter !== 'all' && f.properties.type !== typeFilter) {
                return false;
            }
            
            // Sector filter
            if (sectorFilter !== 'all') {
                const sectorValue = f.properties.sector || f.properties.sectors || '';
                const featureSectors = String(sectorValue).toLowerCase();
                if (!featureSectors.includes(sectorFilter.toLowerCase())) {
                    return false;
                }
            }
            
            // Country filter
            if (countryFilter !== 'all') {
                const location = f.properties.location;
                // Use the same cityToCountry mapping
                const country = cityToCountry[location] || location;
                if (country !== countryFilter) {
                    return false;
                }
            }
            
            // Search filter
            if (searchInput.length > 0) {
                const searchableText = [
                    f.properties.name,
                    f.properties.description,
                    f.properties.bio,
                    f.properties.sector,
                    f.properties.sectors,
                    f.properties.skills,
                    f.properties.skillsInHouse,
                    f.properties.tags,
                    f.properties.networks,
                    f.properties.passions,
                    f.properties.superpowers,
                    f.properties.offers,
                    f.properties.needs
                ].filter(Boolean).join(' ').toLowerCase();
                
                if (!searchableText.includes(searchInput)) {
                    return false;
                }
            }
            
            return true;
        });
        
        // Update source with filtered data
        const source = map.getSource('gaianet-data') as mapboxgl.GeoJSONSource;
        if (source) {
            source.setData({
                type: 'FeatureCollection',
                features: filteredData
            });
        }
        
        // Update counter
        document.getElementById('visibleCount')!.textContent = filteredData.length.toString();
        
        console.log(`Filtered to ${filteredData.length} features (${filteredData.filter((f: any) => f.properties.type === 'Projects').length} projects, ${filteredData.filter((f: any) => f.properties.type === 'Members').length} members)`);
    };
    
    // Attach filter event listeners
    document.getElementById('typeFilter')!.addEventListener('change', applyFilters);
    document.getElementById('sectorFilter')!.addEventListener('change', applyFilters);
    document.getElementById('countryFilter')!.addEventListener('change', applyFilters);
    document.getElementById('showGlobal')!.addEventListener('change', applyFilters);
    document.getElementById('search')!.addEventListener('input', applyFilters);
}

